// frontend/src/components/common/StaffGate.jsx
//
// Render-time access gate for staff-only pages. Wraps the page element
// so the check fires both when the page is first navigated to via URL
// AND when TabsHost renders it as a tab (which doesn't go through the
// router's <Outlet/> match chain).
//
// A guard on the router's <Outlet/> would fire only on URL match: switching
// back to an open staff tab via the tab strip would skip it.

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function StaffGate({ children }) {
  const { userContext } = useAuth();
  const isStaff = userContext?.user?.is_staff ?? false;
  if (!isStaff) return <Navigate to="/" replace />;
  return children;
}
